enum VideoCodec {
  H264 = 'H264',
  VP8 = 'VP8'
}

export {
  VideoCodec
}
